import groupBy from 'lodash/groupBy';
import get from 'lodash/get';

export const defaultProgressStatuses = {
  not_started: 0,
  started: 0,
  submitted: 0,
  ready_to_score: 0,
  scoring: 0,
  mcq_scoring: 0,
  complete: 0,
  student_scored: 0,
  scored: 0,
  teacher_and_student_scored: 0,
  no_answer_sheet: 0,
  answer_sheet_generated: 0,
  answer_sheet_issues: 0,
};

export const ANSWER_SHEET_STATUS = {
  NOT_STARTED: 'no_answer_sheet',
  GENERATED: 'answer_sheet_generated',
  HAS_ISSUES: 'answer_sheet_issues',
};

export default function getSubmissionsAndProgressWithAnswerSheet(
  submissions,
  studentSessions,
  ps_sessions,
) {
  const statusesToReplaceWith = new Set(['not_started', 'started']);
  const paperscorer_sessions = ps_sessions || [];
  const psSessionsByUserId = paperscorer_sessions.reduce(
    (acc, session) => Object.assign(acc, { [session.user_id]: session }),
    {},
  );

  const studentSessionsByUser = groupBy(studentSessions, 'userId');

  const getPsSessionStatus = (session = {}) => {
    if (!session.form_id) return ANSWER_SHEET_STATUS.NOT_STARTED;
    if (session.form_id && !session.errors)
      return ANSWER_SHEET_STATUS.GENERATED;
    if (session.form_id && session.errors)
      return ANSWER_SHEET_STATUS.HAS_ISSUES;
    return undefined;
  };

  return submissions.reduce(
    (acc, submission) => {
      const studentSession = get(
        studentSessionsByUser,
        `[${submission.user_id}][0]`,
      );
      const progress = studentSession?.progress || {};
      const sessionStatuses = Object.keys(progress).filter(
        (status) => progress[status] === 1,
      );
      const sessionStatus = get(sessionStatuses, '[0]', submission.status);

      let shouldStatusChange = statusesToReplaceWith.has(sessionStatus);
      const status = shouldStatusChange
        ? getPsSessionStatus(psSessionsByUserId[submission.user_id])
        : sessionStatus;

      const currentCount = acc.progressWithAs[status] || 0;
      const updatedProgress = Object.assign(acc.progressWithAs, {
        [status]: currentCount + 1,
      });
      const updatedSubmissions = [
        ...acc.submissionsWithAs,
        shouldStatusChange ? Object.assign(submission, { status }) : submission,
      ];

      return {
        progressWithAs: updatedProgress,
        submissionsWithAs: updatedSubmissions,
      };
    },
    { progressWithAs: { ...defaultProgressStatuses }, submissionsWithAs: [] },
  );
}
